<button
  type="button"
  tabindex="0"
  class="toggle-options-action"
  trackable
  [trackingObject]="trackingObject"
  [trackingAction]="moreOptionsAction"
  (click)="togglePopup()"
>
  <div class="toggle-options-content">
    {{ triggerText }}

    <app-icon class="toggle-options-icon" [icon]="chevronDownIcon"> </app-icon>
  </div>
</button>

<div class="popup" [hidden]="!showPopup">
  <app-form-master
    *ngIf="form"
    [form]="form"
    (validFormChanges)="updateDocumentItemOptions($event)"
  >
    <!-- TAX SECTION-->
    <div class="form-section">
      <ng-container *ngFor="let tax of taxes">
        <div *ngIf="!taxRates[tax.id]?.isEmpty()" class="form-row">
          <div [ngSwitch]="taxRates[tax.id].size > 1" class="tax-rates">
            <ng-container *ngSwitchCase="true">
              <app-checkbox-field
                class="checkbox"
                [label]="tax.name"
                fieldId="tax_{{ tax.id }}_field"
                [fieldControl]="form.get(getFormKeysForTax(tax)[0])"
                [trackingObject]="trackingObject"
                trackingIdentifier="tax"
                [trackingScreenName]="trackingScreenName"
              >
              </app-checkbox-field>

              <app-select-field
                label="{{
                  'LABEL.TAX_RATES' | translate: { taxName: tax.name }
                }}"
                [hideLabel]="true"
                [values]="taxRates[tax.id]"
                [formControl]="form.get(getFormKeysForTax(tax)[1])"
                [trackingObject]="trackingObject"
                [trackingSelected]="taxDropdownSelectedAction"
              >
              </app-select-field>
            </ng-container>

            <div *ngSwitchDefault class="checkbox-wrapper">
              <app-checkbox-field
                label="{{ tax.name }} ({{ taxRates[tax.id]?.get(0).key }})"
                fieldId="tax_{{ tax.id }}_field"
                [fieldControl]="form.get(getFormKeysForTax(tax)[0])"
                [trackingObject]="trackingObject"
                trackingIdentifier="tax"
                [trackingScreenName]="trackingScreenName"
              >
              </app-checkbox-field>
            </div>
          </div>
        </div>
      </ng-container>

      <!--  WITHHOLDING TAX SECTION -->
      <div *ngIf="withholdingTax?.enabled" class="form-row">
        <app-checkbox-field
          label="{{ withholdingTax?.name }} ({{
            withholdingTax?.rate | percentage: locale:3
          }})"
          fieldId="withholding_tax_field"
          [fieldControl]="form.get(formKeys.ENABLE_WITHHOLDING_TAX)"
          [trackingObject]="trackingObject"
          trackingIdentifier="withholding_tax"
          [trackingScreenName]="trackingScreenName"
        >
        </app-checkbox-field>
      </div>
    </div>

    <!-- UNIT TYPE -->
    <div class="form-section">
      <!-- PARTS OR LABOR-->
      <div *ngIf="documentSettings?.separatePartsAndLabor" class="form-row">
        <app-select-field
          class="parts-or-labor-select-field"
          [label]="'LABEL.PARTS_OR_LABOR' | translate"
          fieldId="parts_or_labor_field"
          [formControl]="form.get(formKeys.PARTS_OR_LABOR)"
          [values]="partsOrLaborOptions"
          [trackingObject]="trackingObject"
          [trackingSelected]="partsOrLaborSelected"
        >
        </app-select-field>
      </div>

      <div class="form-row labor-section">
        <app-checkbox-field
          class="checkbox"
          [label]="'LABEL.DAYS_OR_HOURS' | translate"
          fieldId="enable_labor_type_field"
          [fieldControl]="form.get(formKeys.ENABLE_LABOR_TYPE)"
        >
        </app-checkbox-field>

        <app-select-field
          [label]="'LABEL.LABOR_UNIT' | translate"
          [hideLabel]="true"
          fieldId="labor_type_field"
          [formControl]="form.get(formKeys.LABOR_TYPE)"
          [values]="laborTypeOptions"
          [trackingObject]="trackingObject"
          [trackingSelected]="laborTypeSelected"
        >
        </app-select-field>
      </div>
    </div>

    <div *ngIf="showMarkup || showDiscount" class="form-section">
      <!-- MARKUP SECTION (EXPENSES ONLY) -->
      <div *ngIf="showMarkup" class="form-row markup-wrapper">
        <app-checkbox-field
          class="checkbox"
          [label]="'LABEL.MARKUP' | translate"
          fieldId="markup_field"
          [fieldControl]="form.get(formKeys.ENABLE_MARKUP)"
          [trackingObject]="trackingObject"
          trackingIdentifier="markup"
          [trackingScreenName]="trackingScreenName"
        >
        </app-checkbox-field>

        <div class="value-switch-field-wrapper">
          <app-value-switch-field
            class="value-switch-field"
            fieldId="markup_value_switch_field"
            [switches]="markupSwitches"
            [formControl]="form.get(formKeys.MARKUP_TYPE)"
          >
          </app-value-switch-field>

          <app-currency-field
            class="currency-field"
            [label]="'LABEL.MARKUP' | translate"
            fieldId="markup_amount_field"
            [formControl]="form.get(formKeys.MARKUP_AMOUNT)"
            [currencyCode]="currencyCode"
            [hideLabel]="true"
            [locale]="locale"
            [hidden]="
              form.get(formKeys.MARKUP_TYPE).value !== MarkupTypesEnum.amount
            "
          >
          </app-currency-field>

          <app-percentage-field
            class="percentage-field"
            [label]="'LABEL.MARKUP' | translate"
            fieldId="markup_percentage_field"
            [formControl]="form.get(formKeys.MARKUP_PERCENTAGE)"
            [hideLabel]="true"
            [hidden]="
              form.get(formKeys.MARKUP_TYPE).value !==
              MarkupTypesEnum.percentage
            "
            [locale]="locale"
          >
          </app-percentage-field>
        </div>
      </div>

      <!-- DISCOUNT SECTION -->
      <div *ngIf="showDiscount" class="form-row discount-wrapper">
        <app-checkbox-field
          class="checkbox"
          [label]="'LABEL.DISCOUNT' | translate"
          fieldId="discount_field"
          [fieldControl]="form.get(formKeys.ENABLE_DISCOUNT)"
          [trackingObject]="trackingObject"
          trackingIdentifier="discount"
          [trackingScreenName]="trackingScreenName"
        >
        </app-checkbox-field>

        <div class="value-switch-field-wrapper">
          <app-value-switch-field
            class="value-switch-field"
            fieldId="discount_value_switch_field"
            [switches]="discountSwitches"
            [formControl]="form.get(formKeys.DISCOUNT_TYPE)"
          >
          </app-value-switch-field>

          <app-currency-field
            class="currency-field"
            [label]="'LABEL.DISCOUNT' | translate"
            fieldId="discount_amount_field"
            [currencyCode]="currencyCode"
            [locale]="locale"
            [hideLabel]="true"
            [formControl]="form.get(formKeys.DISCOUNT_AMOUNT)"
            [hidden]="
              form.get(formKeys.DISCOUNT_TYPE).value !==
              DiscountTypesEnum.amount
            "
          >
          </app-currency-field>

          <app-percentage-field
            class="percentage-field"
            [label]="'LABEL.DISCOUNT' | translate"
            fieldId="discount_percentage_field"
            [hideLabel]="true"
            [formControl]="form.get(formKeys.DISCOUNT_PERCENTAGE)"
            [locale]="locale"
            [hidden]="
              form.get(formKeys.DISCOUNT_TYPE).value !==
              DiscountTypesEnum.percentage
            "
          >
          </app-percentage-field>
        </div>
      </div>
    </div>
  </app-form-master>
</div>
